import styled from 'styled-components';

export const FormWrapper = styled.form``;

export const ControlGroup = styled.fieldset`
  margin: 0;
  padding: 0;
  border: 0;
  color: #292a2b;

  & > *:not(:last-child) {
    margin-bottom: 6px;
  }

  input {
    margin-bottom: 12px;
  }

  input,
  textarea {
    color: inherit;

    &::-webkit-input-placeholder {
      color: #919eaa;
    }
  }
`;
